export enum DialogButtonText {
  ok = 'OK',
  cancel = 'Cancel',
  yes = 'Yes',
  no = 'No',
  continue = 'Continue',
}
